import React, { useEffect, useRef } from "react";

export function useTimeout(
  callback: React.EffectCallback,
  delay: number = 3000,
): React.MutableRefObject<number> {
  const timeoutRef = useRef<number>();
  const callbackRef = useRef(callback);

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  useEffect(() => {
    timeoutRef.current = window.setTimeout(() => callbackRef.current(), delay);

    return () => window.clearTimeout(timeoutRef.current);
  }, [delay]);

  return timeoutRef;
}
